// Copyright 2026. WebPros International GmbH. All rights reserved.

import { useMemo } from 'react';
import { IBackupNodeResponse } from 'common/api/resources/BackupNode';
import {
    Heading,
    Icon,
    List,
    Text,
    Tooltip,
    Translate,
} from '@plesk/ui-library';
import { ListColumn } from '@plesk/ui-library/types/components/List';
import { TheadWithTooltip } from 'admin/disasterRecovery/components/Styles';

interface IProps {
    backupNodes: IBackupNodeResponse[];
}

export default function BackupNodesTable({
    backupNodes,
}: IProps) {

    const columns = useMemo((): Array<ListColumn<IBackupNodeResponse>> => ([
        {
            key: 'name',
            title: <Translate content={'disasterRecovery.readinessStatus.backupNodes.table.name'} />,
        },
        {
            key: 'type',
            title: <Translate content={'disasterRecovery.readinessStatus.backupNodes.table.type'} />,
        },
        {
            key: 'restoreCount',
            title: (
                <Tooltip title={(
                    <div>
                        <p><Translate content="disasterRecovery.readinessStatus.concurrentRestoreCountTooltip.p1"/></p>
                        <p><Translate content="disasterRecovery.readinessStatus.concurrentRestoreCountTooltip.p2"/></p>
                        <p><Translate content="disasterRecovery.readinessStatus.concurrentRestoreCountTooltip.p3"/></p>
                    </div>
                )}>
                    <TheadWithTooltip>
                        <Translate content={'disasterRecovery.readinessStatus.concurrentRestoreCount'} />

                        <Icon name={'question-mark-circle'} />
                    </TheadWithTooltip>
                </Tooltip>
            ),
            render: row => <span>{row.settings.concurrent_backups.restore}</span>,
        },
    ]), []);

    return (
        <div style={{ marginBottom: 16 }}>
            <Heading level={3}>
                <Translate content="disasterRecovery.readinessStatus.backupNodes.title" />
            </Heading>

            <List
                columns={columns}
                data={backupNodes}
                rowKey={(item) => String(item.id)}
                emptyView={(
                    <Text component={'p'}>
                        <Translate content={'disasterRecovery.readinessStatus.destinationComputeResources.emptyList'} />
                    </Text>
                )}
            />
        </div>
    );
}

